import { useRef } from 'react';

export type UseCustomEventHook<T> = {
	
	/* Subscription method with unsubscription method as a return. Use in a useEffect clause for efficient pub/sub. */
	subscribe( listener: ( e: CustomEvent<T> ) => void ): () => void,
	
	/* Unsubscribe method for manual detachment */
	unsubscribe( listener: () => void ): void,
	
	/* Publish data to the custom event */
	publish( data: T ): void,
};

export function useCustomEvent<T = any>( _eventName: string ): UseCustomEventHook<T>{
	
	const eventName = useRef( _eventName );
	
	function subscribe( listener ){
		
		document.addEventListener( eventName.current, listener );
		
		return () => {
			document.removeEventListener( eventName.current, listener );
		}
	}
	
	function unsubscribe( listener ){
		document.removeEventListener( eventName.current, listener );
	}
	
	function publish( data: T ){
		const event = new CustomEvent( eventName.current, { detail: data } );
		document.dispatchEvent( event );
	}
	
	return {
		subscribe,
		unsubscribe,
		publish,
	};
}
